module.exports = __webpack_public_path__ + "static/media/x.41d4af0a.svg";